export type MessageRole = 'customer' | 'assistant';

export interface Message {
  id: string;
  role: MessageRole;
  text: string;
  timestamp: Date;
}

export type ChatView = 'welcome' | 'conversation';

export interface PredefinedOption {
  id: string;
  label: string;
  response: string;
}

export const PREDEFINED_OPTIONS: PredefinedOption[] = [
  { 
    id: 'meal-plan', 
    label: '🍱 Find My Meal Plan', 
    response: 'Absolutely. I can help you find a meal plan based on your goals, preferences and schedule.' 
  },
  { 
    id: 'recommendations', 
    label: '🥗 Meal Recommendations', 
    response: 'I can help you choose meals based on your preferences. What kind of meals are you looking for?' 
  },
  { 
    id: 'protein', 
    label: '💪 High Protein Meals', 
    response: 'I can help you find our protein-rich meal options.' 
  },
  { 
    id: 'subscription', 
    label: '📅 Subscription & Meal Plans', 
    response: 'I can help you explore our meal plans, durations and meal combinations.' 
  },
  { 
    id: 'delivery', 
    label: '📍 Delivery Areas & Timings', 
    response: 'I can help you with delivery availability and timings.' 
  },
  { 
    id: 'pricing', 
    label: '💳 Pricing & Payment', 
    response: 'I can help you with pricing and payment questions.' 
  },
  { 
    id: 'track', 
    label: '📦 Track My Order', 
    response: 'I can help you with your order. Please provide your order number.' 
  },
  { 
    id: 'general', 
    label: '❓ General Questions', 
    response: 'Sure. Please tell me what you\'d like to know.' 
  },
];
